/**
 *
 * key
 *
 */

 const key = 'YWx0ZXJRdW90ZUxpc3Q='

 export default key
 